import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { SnackbarNotificationService } from "../ui-kit/notifications/snackbar-notification/snackbar-notification.service";
import { MatDialog } from "@angular/material/dialog";
import { switchMap, tap } from "rxjs";
import { ErrorAction } from "src/app/core/events/error.actions";
import { GenericErrorDialogComponent } from "../ui-kit/dialogs/generic-error-dialog/generic-error-dialog.component";
import { UserActionInvalidDialogComponent } from "../ui-kit/dialogs/user-action-invalid-dialog/user-action-invalid-dialog.component";
import { UserActionForbiddenDialogComponent } from "../ui-kit/dialogs/user-action-forbidden-dialog/user-action-forbidden-dialog.component";

@Injectable()
export class ErrorNotificationEffects {

    readonly notifyUnknownError$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ErrorAction.unkonwnError),
            switchMap(() => this.translateService.get('messages.errors.generic')),
            tap((message) => this.snackbarNotificationService.openError(message)),
        ), { dispatch: false }
    )

    readonly notifyGenericError$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ErrorAction.genericError),
            tap((action) => this.matDialog.open(GenericErrorDialogComponent, { data: action.message })),
        ), { dispatch: false }
    )

    readonly notifyInvalidOperationError$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ErrorAction.invalidOperationError),
            tap((action) => this.matDialog.open(UserActionInvalidDialogComponent, { data: action.errors })),
        ), { dispatch: false }
    )

    readonly notifyForbiddenOperationError$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ErrorAction.forbiddenOperationError),
            tap((action) => this.matDialog.open(UserActionForbiddenDialogComponent, { data: action.errors })),
        ), { dispatch: false }
    )

    constructor(
        private readonly store: Store,
        private readonly actions$: Actions,
        private readonly translateService: TranslateService,
        private readonly snackbarNotificationService: SnackbarNotificationService,
        private readonly matDialog: MatDialog
    ) { }
}